import type { ReactNode } from "react";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { getNodeIdExistsSelector } from "@skilitics/nautilus-core-designer-data";

import { useGetContextNodeActions } from "../state";
import { ContextPanelSelectedNodeContext } from "./ContextPanelSelectedNodeContext";

export const ContextPanelSelectedNodeProvider = ({ children }: { children: ReactNode }) => {
  const [contextPanelSelectedNodeId, setContextPanelSelectedNodeId] = useState<number | undefined>();
  const getNodeIdExists = useSelector(getNodeIdExistsSelector);
  const getNodeActions = useGetContextNodeActions();

  const nodeActions = useMemo(
    () =>
      contextPanelSelectedNodeId && getNodeIdExists(contextPanelSelectedNodeId)
        ? getNodeActions(contextPanelSelectedNodeId)
        : [],
    [contextPanelSelectedNodeId, getNodeIdExists, getNodeActions],
  );

  return (
    <ContextPanelSelectedNodeContext.Provider
      value={{
        contextPanelSelectedNodeId,
        onContextPanelSelectedNodeIdChanged: setContextPanelSelectedNodeId,
        nodeActions,
      }}
    >
      {children}
    </ContextPanelSelectedNodeContext.Provider>
  );
};
